import { d as dateToDateString } from './util3.js';
import { a as addDays, c as subMonths, s as startOfMonth } from './subMonths.js';

/**
 * The {@link subDays} function options.
 */

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 * @param options - An object with options
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount, options) {
  return addDays(date, -amount, options);
}

const DATE_RANGE_PRESETS = {
    '7_DAYS': {
        label: 'Last 7 days',
        value: () => [dateToDateString(subDays(new Date(), 7)), dateToDateString(new Date())],
    },
    '14_DAYS': {
        label: 'Last 14 days',
        value: () => [dateToDateString(subDays(new Date(), 14)), dateToDateString(new Date())],
    },
    '30_DAYS': {
        label: 'Last 30 days',
        value: () => [dateToDateString(subDays(new Date(), 30)), dateToDateString(new Date())],
    },
    '60_DAYS': {
        label: 'Last 60 days',
        value: () => [dateToDateString(subDays(new Date(), 60)), dateToDateString(new Date())],
    },
    '90_DAYS': {
        label: 'Last 90 days',
        value: () => [dateToDateString(subDays(new Date(), 90)), dateToDateString(new Date())],
    },
    '12_MONTHS': {
        label: 'Last 12 months',
        value: () => [dateToDateString(subMonths(new Date(), 12)), dateToDateString(new Date())],
    },
    MONTH_TO_DATE: {
        label: 'Month to date',
        value: () => [dateToDateString(startOfMonth(new Date())), dateToDateString(new Date())],
    },
    CUSTOM: {
        label: 'Custom',
        value: () => [null, null],
    },
};

export { DATE_RANGE_PRESETS as D };

//# sourceMappingURL=constants.js.map